const commonSlp = require("./slp.common").default;

export default {
    ...commonSlp,
    jobs: []
};
